import React from 'react'

import { Col, Grid } from '../structure/Grid'
import ConditionalLink from '../actions/ConditionalLink'
import Icon from '../shapes/Icon'
import Text from './Text'

const IconText = ({
  icon,
  iconLeft,
  iconRight,
  label,
  iconColor,
  iconSize,
  gutter,
  gap,
  path,
  onClick,
  buttonTextBold,
  justify,
  ...props
}) => {
  const iconProps = { size: iconSize || 0.8, color: iconColor || props.color }
  iconLeft = iconLeft || icon

  return (
    <ConditionalLink onClick={onClick} path={path} block {...props}>
      <Grid gap={gap || gutter || 0.5} align="center" justify={justify}>
        {iconLeft && (
          <Col>
            <Icon name={iconLeft} {...iconProps} />
          </Col>
        )}
        <Text size="small" bold={buttonTextBold || false} {...props}>
          {label}
        </Text>
        {iconRight && (
          <Col>
            <Icon name={iconRight} {...iconProps} />
          </Col>
        )}
      </Grid>
    </ConditionalLink>
  )
}

export default IconText
